import { catalog } from '@nolens/i18n';

export const miscText = catalog(
  {
    inviteTo: (ws: string) => `Invite to ${ws}`,
    inviteHint: (role: string) =>
      `You'll join the team as ${role.toLowerCase()} and see its guides.`,
    acceptInvite: 'Accept invite',
    embedOff: 'This guide can only be embedded in other pages with Pro or Pro Team.',
    openGuide: 'Open the guide',
    untitled: 'Untitled',
    madeWith: 'Made with',
    extensionTitle: 'Chrome extension',
    extensionHint:
      'The extension records guides while you work and only works when connected to your account. When you “Finish”, the guide comes here and opens.',
    lookingForExtension: 'Looking for the extension…',
    extensionNotFound: 'Extension not found',
    extensionNotFoundHint:
      "Install the Nolens Guides extension in Chrome. Once it's installed, this page finds it on its own.",
    extensionNotFoundStore:
      "Install the Nolens Guides extension from the Chrome Web Store. Once it's installed, this page finds it on its own.",
    installExtension: 'Install the extension',
    searchAgain: 'Search again',
    installed: (v: string) => `Extension ${v} installed.`,
    linkedTo: 'Connected to',
    notLinked: 'Not connected to any account yet.',
    connectTo: (email: string) => `Connect to ${email}`,
    thisAccount: 'this account',
    linked: 'Done. The guides you finish now appear in your library.',
    firstGuideTitle: 'To record your first guide',
    firstGuidePin:
      'Pin the icon: in the Chrome toolbar, click Extensions (🧩), then the pin next to Nolens Guides.',
    firstGuideRecord:
      'Open the page where the process starts, click the Nolens icon and press “Start recording”.',
    firstGuideFinish: 'Do the process and press “Finish”: the guide appears in your library.',
    historyNote:
      "When you installed it, Chrome said the extension can read your browsing history. It doesn't: it only follows tabs and addresses during a recording, to keep up when you switch tabs or type an address.",
    refused: "The extension didn't accept the connection.",
    backToGuides: 'Back to guides',
    pageNotFound: 'Page not found',
    pageNotFoundHint: "The address doesn't exist.",
    goToGuides: 'Go to guides',
    offline: 'No connection. Check your network and try again.',
    extensionNoReply: "The extension didn't respond.",
  },
  {
    'pt-PT': {
      inviteTo: (ws) => `Convite para ${ws}`,
      inviteHint: (role) =>
        `Vai entrar na equipa como ${role.toLowerCase()} e passa a ver os guias dela.`,
      acceptInvite: 'Aceitar convite',
      embedOff: 'Este guia só pode ser incorporado noutras páginas com o Pro ou o Pro Equipa.',
      openGuide: 'Abrir o guia',
      untitled: 'Sem título',
      madeWith: 'Feito com',
      extensionTitle: 'Extensão para o Chrome',
      extensionHint:
        'A extensão grava os guias enquanto trabalha e só funciona ligada à sua conta. Ao «Concluir», o guia vem para aqui e abre-se.',
      lookingForExtension: 'A procurar a extensão…',
      extensionNotFound: 'Extensão não encontrada',
      extensionNotFoundHint:
        'Instale a extensão Nolens Guides no Chrome. Quando estiver instalada, esta página encontra-a sozinha.',
      extensionNotFoundStore:
        'Instale a extensão Nolens Guides a partir da Chrome Web Store. Quando estiver instalada, esta página encontra-a sozinha.',
      installExtension: 'Instalar a extensão',
      searchAgain: 'Procurar outra vez',
      installed: (v) => `Extensão ${v} instalada.`,
      linkedTo: 'Ligada a',
      notLinked: 'Ainda não está ligada a nenhuma conta.',
      connectTo: (email) => `Ligar a ${email}`,
      thisAccount: 'esta conta',
      linked: 'Pronto. Os guias que concluir passam a aparecer na sua biblioteca.',
      firstGuideTitle: 'Para gravar o 1.º guia',
      firstGuidePin:
        'Fixe o ícone: na barra do Chrome, clique em Extensões (🧩) e no alfinete ao lado de Nolens Guides.',
      firstGuideRecord:
        'Abra a página onde o processo começa, clique no ícone Nolens e carregue em «Começar a gravar».',
      firstGuideFinish:
        'Faça o processo e carregue em «Concluir»: o guia aparece na sua biblioteca.',
      historyNote:
        'Ao instalar, o Chrome disse que a extensão pode ler o histórico de navegação. Não lê: só segue os separadores e os endereços durante uma gravação, para acompanhar quando muda de separador ou escreve um endereço.',
      refused: 'A extensão não aceitou a ligação.',
      backToGuides: 'Voltar aos guias',
      pageNotFound: 'Página não encontrada',
      pageNotFoundHint: 'O endereço não existe.',
      goToGuides: 'Ir para os guias',
      offline: 'Sem ligação. Verifique a rede e tente outra vez.',
      extensionNoReply: 'A extensão não respondeu.',
    },
  },
);
